export function PhoneMask(phone: string) {
  return phone
    .replace(/\D/g, '')
    .replace(/^(\d)/, '($1')
    .replace(/^(\(\d{2})(\d)/, '$1) $2')
    .replace(/(\d{5})(\d{1,6})/, '$1-$2')
    .replace(/(-\d{6})\d+?$/, '$1')
}
